import { Mods, mods } from '@approvalmax/theme';
import { font, LoadingBar, Popup } from '@approvalmax/ui';
import styled from 'styled-components';

export const DefaultContent = styled(Popup.DefaultContent)`
    position: relative;
    width: 1280px;
    height: 780px;
    overflow: auto;
`;

export const Body = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 20px 40px 20px 80px;
`;

export const StyledLoadingBar = styled(LoadingBar)<Mods<'progress'>>`
    position: absolute;
    left: 0;
    top: 30px;
    right: 0;
    visibility: hidden;
    transition: opacity 200ms ease-in-out;
    z-index: 1;

    ${mods.progress.true`
        visibility: visible;
    `};
`;

export const Item = styled.div`
    margin: 17px 0 0;
    width: 50%;
    padding-right: 20px;
`;

export const Label = styled.div`
    ${font(12, '#5e5c5c', 'semibold')};
    margin-bottom: 2px;
`;

export const RequiredSymbol = styled.span`
    color: #cb4e30;
`;

export const Description = styled.div`
    ${font(12, '#5e5c5c')};
    margin-top: 2px;
`;
